/**
 * useDarkMode
 *
 * Returns true when the <html> element has the "dark" class.
 * Reactively updates when dark mode is toggled.
 *
 * Usage:
 *   import { useDarkMode } from '@hooks/useDarkMode';
 *   const isDark = useDarkMode();
 */

import { useState, useEffect } from 'react';

export function useDarkMode() {
  const [isDark, setIsDark] = useState(
    () => typeof window !== 'undefined' &&
          document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const obs = new MutationObserver(() =>
      setIsDark(document.documentElement.classList.contains('dark'))
    );
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    return () => obs.disconnect();
  }, []);

  return isDark;
}
